import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIllustration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 41.8124,
			cy: 22.3866,
			r: 13.1874,
			fill: "url(#paint0_linear_1936_54852)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -2.17222,
			y: 9.92739,
			width: 58.2858,
			height: 48.1062,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.32px)",
					clipPath: "url(#bgblur_0_1936_54852_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 6.63316,
			x: 4.96094,
			y: 17.0605,
			width: 44.0212,
			height: 33.8393,
			rx: 7.5,
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_1936_54852)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -2.17222,
			y: 9.92739,
			width: 58.2858,
			height: 48.1062,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_1_1936_54852_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-figma-bg-blur-radius": 7.35296,
			cx: 20.1636,
			cy: 28.9487,
			r: 1.95019,
			fill: "url(#paint2_linear_1936_54852)",
			stroke: "url(#paint3_linear_1936_54852)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -2.17222,
			y: 9.92739,
			width: 58.2858,
			height: 48.1062,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_2_1936_54852_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-figma-bg-blur-radius": 7.35296,
			cx: 33.7808,
			cy: 28.9487,
			r: 1.95019,
			fill: "url(#paint4_linear_1936_54852)",
			stroke: "url(#paint5_linear_1936_54852)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -2.17222,
			y: 9.92739,
			width: 58.2858,
			height: 48.1062,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_3_1936_54852_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 7.35296,
			x: 18.2134,
			y: 37.9185,
			width: 17.5172,
			height: 3.04166,
			rx: 1.52083,
			fill: "url(#paint6_linear_1936_54852)",
			stroke: "url(#paint7_linear_1936_54852)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_1936_54852_clip_path",
				transform: "translate(2.17222 -9.92739)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 4.96094,
					y: 17.0605,
					width: 44.0212,
					height: 33.8393,
					rx: 7.5
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_1936_54852_clip_path",
				transform: "translate(2.17222 -9.92739)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 20.1636,
					cy: 28.9487,
					r: 1.95019
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_2_1936_54852_clip_path",
				transform: "translate(2.17222 -9.92739)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 33.7808,
					cy: 28.9487,
					r: 1.95019
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_3_1936_54852_clip_path",
				transform: "translate(2.17222 -9.92739)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 18.2134,
					y: 37.9185,
					width: 17.5172,
					height: 3.04166,
					rx: 1.52083
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1936_54852",
				x1: 54.9998,
				y1: 22.3866,
				x2: 28.625,
				y2: 22.3866,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1936_54852",
				x1: 2.20988,
				y1: 19.0491,
				x2: 24.3664,
				y2: 62.7776,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1936_54852",
				x1: 18.5301,
				y1: 30.9906,
				x2: 18.6772,
				y2: 26.48,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_1936_54852",
				x1: 9.78532,
				y1: 32.4451,
				x2: 10.3931,
				y2: 24.6865,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_1936_54852",
				x1: 32.1473,
				y1: 30.9906,
				x2: 32.2944,
				y2: 26.48,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_1936_54852",
				x1: 23.4025,
				y1: 32.4451,
				x2: 24.0103,
				y2: 24.6865,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_1936_54852",
				x1: 20.0059,
				y1: 41.0607,
				x2: 20.0276,
				y2: 37.4752,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_1936_54852",
				x1: -17.2883,
				y1: 42.2158,
				x2: -17.1979,
				y2: 36.0181,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgErrorIllustration);
export { ForwardRef as ReactComponent };
